import React from 'react';
import ReactDOM from 'react-dom';
import './style/velocity.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { BrowserRouter } from 'react-router-dom'

ReactDOM.render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
), document.querySelector('#app-container'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js